import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Button from '../../../../../../components/Button'
import InternalLink from '../../../../../../components/InternalLink'

import { ReactComponent as SettingsIcon } from '../../../../../../assets/icons/settings.svg'
import { ReactComponent as LogoutIcon } from '../../../../../../assets/icons/logout.svg'

import { handleLogout } from '../../../../../../helpers/auth'
import { isAccountSetupModeSelector } from '../../../../../../modules/selectors/app'

import { ROUTES } from '../../../../../../constants/routes'

import useStyles from './style'

function UserNav({ closeMenu }) {
  const classes = useStyles()
  const isAccountSetupMode = useSelector(isAccountSetupModeSelector)

  const logoutHandler = () => {
    handleLogout()
  }

  const onLinkClick = () => {
    closeMenu && closeMenu()
  }

  return (
    <ul className={classes.userMenu}>
      {/*don't show settings page for user during setting up account */}
      {!isAccountSetupMode && (
        <li>
          <InternalLink className={classes.userMenuLink} to={ROUTES.settings} onClick={onLinkClick}>
            <Button className={classes.userMenuButton}>
              <SettingsIcon />
              Settings
            </Button>
          </InternalLink>
        </li>
      )}
      <li>
        <Button className={classes.userMenuButton} onClick={logoutHandler}>
          <LogoutIcon />
          Logout
        </Button>
      </li>
    </ul>
  )
}

UserNav.propTypes = {
  closeMenu: PropTypes.func
}

export default UserNav
